var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.0813 14.0809L17.6366 14.1186V1.91873C17.6366 0.855732 16.7808 0 15.7178 0C14.6552 0 13.7991 0.855732 13.7991 1.91873L13.8367 14.0813H1.91873C0.855732 14.0813 0 14.937 0 16C0 17.0627 0.855732 17.9184 1.91873 17.9184H13.8179V30.0813C13.8179 31.1436 14.6737 32 15.7366 32C16.7996 32 17.6554 31.1436 17.6554 30.0813V17.9187H30.0813C31.1443 17.9187 32 17.0623 32 16C32 14.9367 31.1347 14.0809 30.0813 14.0809Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.443368f9a3cace19ebd6f79a0d424171.svg";
export { ForwardRef as ReactComponent };